<div class="sidenav-container">
  <!-- Backdrop -->
  <div class="sidenav-backdrop" [class.open]="isOpen" (click)="onBackdropClick()"></div>

  <!-- Sidenav Panel -->
  <div class="sidenav-panel" [class.open]="isOpen">
    <!-- Header -->
    <div class="sidenav-header">
      <button class="sidenav-close-button" type="button" (click)="onToggle()">
        <iconify-icon icon="bitcoin-icons:cross-outline"></iconify-icon>
      </button>

      <div class="sidenav-header-content">
        <a routerLink="/home" class="sidenav-header-logo"><img src="/img/greatday_logo.svg" [alt]="'header.logo' | translate"></a>
        @if (userName$ | async; as userName) {
          <div class="sidenav-user-greeting">{{ 'sidenav.welcomeUser' | translate:{ name: userName } }}</div>
        } @else {
          <div class="sidenav-user-greeting">{{ 'sidenav.welcome' | translate }}</div>
        }
      </div>
    </div>

    <!-- Navigation Items -->
    <nav class="sidenav-nav">
      <div class="nav-section">
        <a mat-button class="nav-item" routerLink="/home" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}" (click)="closeSidenav.emit()">
          <iconify-icon icon="heroicons-outline:home"></iconify-icon>
          <span>{{ 'sidenav.navigation.home' | translate }}</span>
        </a>
        <a mat-button class="nav-item" routerLink="/settings" routerLinkActive="active"
           (click)="closeSidenav.emit()">
          <iconify-icon icon="heroicons-outline:cog"></iconify-icon>
          <span>{{ 'sidenav.navigation.settings' | translate }}</span>
        </a>
      </div>
    </nav>

    <!-- Footer -->
    <div class="sidenav-footer">
      <div class="footer-buttons-wrapper">
        <button mat-button class="nav-item" (click)="openLanguageSelector()">
          <span class="nav-item-flag">{{ currentLanguageFlag }}</span>
          <span>{{ currentLanguageLabel }}</span>
        </button>

        <button mat-button class="nav-item logout-button" (click)="logout()">
          <iconify-icon icon="circum:logout"></iconify-icon>
          <span>{{ 'settings.logout' | translate }}</span>
        </button>
      </div>

      @if (version) {
        <div class="version-info" (click)="showDebugInfo()">
          <span>v{{ version }}</span>
        </div>
      }
    </div>
  </div>
</div>
